import { Component, inject, OnInit } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import {
  NbMenuService,
  NbMenuItem,
  NbSidebarService,
} from '@nebular/theme';
import { AuthService } from '../../../core/auth/auth.service';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { MENU_KEY } from '../../../core/store/menu.store';
import { ProfileQueryService } from '../../services/profile-query.service';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { userStorageKeys } from '../../constants/local-storage-keys.constant';
import { SharedModule } from '../../modules/shared.module';
import { NebularModule } from '../../modules/nebular.module';
import { UserService } from '../../services/user.service';
import { Observable } from 'rxjs';
import { UserResponse } from '../../models/user.model';
import { SystemImageStore } from '../../../core/store/system-image.store';

@Component({
  selector: 'ngx-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    NebularModule
  ],
})
export class HeaderComponent implements OnInit {
  themes: string[] = ['default', 'dark', 'cosmic'];
  selectedTheme: string;
  user$: Observable<UserResponse>;
  userMenu = [
    { title: 'Profile', icon: 'person', data: 'editProfile' },
    { title: 'Change Password', icon: 'lock', data: 'changePassword' },
    { title: 'Log out', icon: 'log-out-outline', data: 'logout' },
  ] as NbMenuItem[];
  readonly #userQuery = inject(ProfileQueryService);
  query = injectQuery(() => this.#userQuery.getCurrentProfileOptions());
  readonly systemImageStore = inject(SystemImageStore);

  constructor(
    protected authService: AuthService,
    private themeService: ThemeService,
    private menuService: NbMenuService,
    private router: Router,
    private sidebarService: NbSidebarService,
    private localStorageService: LocalStorageService,
    private userService: UserService
  ) {
    this.selectedTheme = this.themeService.getCurrentTheme();
    this.menuService
      .onItemClick()
      .subscribe((res) => {
        switch (res.item.data) {
          case 'logout':
            this.localStorageService.removeKeys([MENU_KEY, ...userStorageKeys]);
            this.authService.logout();
            break;
          case 'editProfile':
            this.router.navigate(['profile']);
            break;
          case 'changePassword':
            this.router.navigate(['change-password']);
            break;

          default:
            break;
        }
      });
    
    this.user$ = this.userService.getCurrentUser(); // TODO: Move it to a State after succesful login
  }

  ngOnInit(): void {
    this.sidebarSize();
    window.addEventListener('resize', this.sidebarSize.bind(this));
  }

  onThemeChange(theme: string) {
    this.themeService.setTheme(theme);
    this.selectedTheme = theme;
  }

  toggleSidebar() {
    this.sidebarService.toggle(true, 'left');
  }
  sidebarSize(): void {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 980) {
      this.sidebarService.collapse('menu');
    } else {
      this.sidebarService.expand('menu');
    }
  }

  private loadCurrentUser() {
    this.userService
      .getCurrentUser();
  }
}
